export default __webpack_public_path__ + "static/media/PaymentSuccessImg.1a6d8bae.svg";